import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { forgotpassword } from "../../../redux/authslice";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

const Forgotpage = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [error, setErrors] = useState({});
  const [emailData, setemailData] = useState({
    email: "",
  });

  const Validation = () => {
    const errors = {};
    if (!emailData.email) {
      errors.email = "Email required";
    } else if (
      !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(emailData.email)
    ) {
      errors.email = "Invalid email address";
    }
    setErrors(errors);
    return Object.keys(errors)?.length === 0;
  };

  const HandleChange = (e) => {
    setemailData({
      ...emailData,
      [e.target.name]: e.target.value,
    });
    setErrors({ ...error, [e.target.name]: undefined });
  };

  const HandleNext = (e) => {
    e.preventDefault();
    if (Validation()) {
      dispatch(forgotpassword({ emailData, setemailData, navigate, dispatch }));
    }
  };

  return (
    <div className="login-page-2">
      <p className="accout-p-log">Forgot password?</p>
      <p className="accout-p12">
        No worries! Simply enter the email address you signed up with to receive
        a One-Time Passcode and regain access to your account.
      </p>
      <div className="mar-15">
        <label className="label1" htmlFor="">
          Email address
        </label>
        <input
          type="text"
          className="all-input"
          placeholder="Enter email address"
          name="email"
          value={emailData.email}
          onChange={(e) => HandleChange(e)}
        />
        <p className="error_text">{error.email}</p>
      </div>
      <div className="mar-15" onClick={HandleNext}>
        <button className="login-bt">Next</button>
      </div>
      <div className="mar-15">
        <p className="Sign-up-edu">
          Want to go back?<Link to="/">Login</Link>
        </p>
      </div>
    </div>
  );
};

export default Forgotpage;
